<template>
  <div v-if="msg" class="my-msg-row" :class="{ active: isOpen }">
    <button
      class="my-msg-top"
      @click="toggleOpen"
      :aria-expanded="isOpen.toString()"
    >
      <div class="my-msg-date">{{ msg.date }}</div>
      <div class="my-msg-short no_mobile">{{ msg.message }}</div>
      <div class="my-msg-type">{{ getMsgType(msg.medium) }}</div>
      <div class="mobile_only w-100">
        <div class="my-msg-short">{{ msg.message }}</div>
      </div>
    </button>
    <div class="toggle-open" :aria-expanded="isOpen.toString()">
      <div class="inner-open over--hide">
        {{ msg.message }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    msg: {
      required: true
    }
  },
  data() {
    return {
      isOpen: false,
      msgsType: [
        { text: "SMS", value: "sms" },
        { text: "EMAIL", value: "email" },
        { text: "PUSH", value: "push" }
      ]
    };
  },
  methods: {
    toggleOpen() {
      this.isOpen = !this.isOpen;
    },
    getMsgType(value) {
      const found = this.msgsType.find(t => t.value === value);
      return found ? found.text : "";
    }
  }
};
</script>
